

const KEY_PREFIX = "auditoinnit"

export const AUDIT_FILTERS = KEY_PREFIX + ":filters"
export const AUDIT_PAGINATION = KEY_PREFIX + "::pagination"
export const AUDIT_MAP_FILTERS = KEY_PREFIX + ":map-filters"



export const clearLocalStorage = () => {
    localStorage.removeItem(AUDIT_FILTERS);
    localStorage.removeItem(AUDIT_PAGINATION);
    localStorage.removeItem(AUDIT_MAP_FILTERS);
};